export default [
  {value: 'ADMIN', label: 'Administrátor'},
  {value: 'DEALER', label: 'Vedúci obchodník'},
  {value: 'DEALER_L2', label: 'Obchodník'},
  {value: 'DRIVER', label: 'Šofér'},
  {value: 'SYSTEM_ADMIN', label: 'Systémový administrátor'},
]



// WEBPACK FOOTER //
// ./client/codelist/roles.js